import { NextApiRequest } from 'next'

export const validateEmail = (email: string) => /^\S+@\S+\.\S+$/.test(email)

export const isEmail = (email: string) => email.includes('@')

/**
 * Validates that id must be a string and email and phoneNumber are optional strings
 */
export const validateAuthRequestBody = (body: NextApiRequest['body']) => {
  const { id, email, phoneNumber } = body

  if (typeof id !== 'string') {
    return 'id must be a string'
  }

  if (!email && !phoneNumber) {
    return 'either email or phoneNumber must be provided'
  }

  if (email && typeof email !== 'string') {
    return 'email must be a string'
  }

  if (phoneNumber && typeof phoneNumber !== 'string') {
    return 'phoneNumber must be a string'
  }

  return null
}
